import { render, staticRenderFns } from "./Firings.vue?vue&type=template&id=48e33334&"
import script from "./Firings.vue?vue&type=script&lang=js&"
export * from "./Firings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports